<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, password Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            min-height="calc(100vh - 265px)"
            style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
            <v-card-text
              class="pt-3 pb-0">
              <div
                class="title font-weight-bold black--text mb-1">
                Ubah Password
              </div>

              <div
                class="body-1 mb-4">
                Ubah password profil untuk keamanan akun Anda, dengan mengisi form dibawah ini:
              </div>
            </v-card-text>

            <v-divider
              class="my-4"
              style="border-top: 2px dashed #EBEBEB;" />
              
            <v-card-text
              class="pt-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="6">
                      <ValidationProvider 
                        name="Password Lama" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Password Lama
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. ******"
                          :type="show.old_password ? 'text' : 'password'"
                          :append-icon="show.old_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show.old_password = !show.old_password"
                          :counter="20"

                          v-model="form.old_password"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="6">
                      <ValidationProvider 
                        name="Password Baru" 
                        rules="required|regex|min:8|max:20" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Password Baru
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. ******"
                          :type="show.new_password ? 'text' : 'password'"
                          :append-icon="show.new_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show.new_password = !show.new_password"
                          :counter="20"

                          v-model="form.new_password"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <v-row
            justify="end"
            class="pa-4 pr-1 mt-3">
            <v-col 
              cols="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="20">mdi-checkbox-marked-circle-outline</v-icon>
                
                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          success: false
        },

        show: {
          old_password: false,
          new_password: false
        },

        form: {
          old_password: '',
          new_password: ''
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async fetchDetail () {
        await get(`admin/profile_user/detail`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            // this.form = res.results.data
            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(res.results.data),
              JSON.stringify(this.$store.state.menu)
            )
            this.$store.state.user = res.results.data
          }
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/profile_user/change_password`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              if (this.$refs.form) this.$refs.form.reset()

              this.form = {
                old_password: '',
                new_password: ''
              }
              this.fetchDetail()
              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>